import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { SpinnerComponent } from './spinner/spinner.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { LoadingInterceptor } from './loading.interceptor';
import { Phase2Module } from './phase2/phase2.module';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { AdminFilterTrnComponent } from './admin/admin-filter-trn/admin-filter-trn.component';
import { MatDialogComponent } from './shared-components/mat-dialog/mat-dialog.component';
import { FileUploadComponent } from './shared-components/file-upload/file-upload.component';
import { HrFileUploadComponent } from './shared-components/hr-file-upload/hr-file-upload.component';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { DatePipe } from '@angular/common';
import { ErrorInterceptor } from './services/interceptor/error.interceptor';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { TimeoutInterceptor } from './timeout.interceptor';
import { MatExpansionModule } from '@angular/material/expansion';

@NgModule({
  declarations: [
    AppComponent,
    SpinnerComponent,
    MatDialogComponent
    
    // HrErrorLogComponent,
    // HrToSfComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    MatSnackBarModule,
    BrowserAnimationsModule,
    HttpClientModule,
    PdfViewerModule,
    MatDialogModule,
    MatButtonModule
    
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true
    },
    { 
      provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true 
    },
    {
      provide: HTTP_INTERCEPTORS, useClass: TimeoutInterceptor, multi: true
    },
    DatePipe,
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
